{
  "a": {
    "type": "vowel",
    "glyph": "अ",
    "matra": ""
  },
  "A": {
    "type": "vowel",
    "glyph": "आ",
    "matra": "ा"
  },
  "ā": {
    "type": "vowel",
    "glyph": "आ",
    "matra": "ा"
  },
  "aa": {
    "type": "vowel",
    "glyph": "आ",
    "matra": "ा"
  },
  "ae": {
    "type": "vowel",
    "glyph": "ॲ",
    "matra": "ॅ"
  },
  "ai": {
    "type": "vowel",
    "glyph": "ऐ",
    "matra": "ै"
  },
  "au": {
    "type": "vowel",
    "glyph": "औ",
    "matra": "ौ"
  },
  "aw": {
    "type": "vowel",
    "glyph": "ऑ",
    "matra": "ॉ"
  },
  "b": {
    "type": "consonant",
    "glyph": "ब"
  },
  "bh": {
    "type": "consonant",
    "glyph": "भ"
  },
  "ch": {
    "type": "consonant",
    "glyph": "च"
  },
  "chh": {
    "type": "consonant",
    "glyph": "छ"
  },
  "d": {
    "type": "consonant",
    "glyph": "द"
  },
  "D": {
    "type": "consonant",
    "glyph": "ड"
  },
  "dh": {
    "type": "consonant",
    "glyph": "ध"
  },
  "Dh": {
    "type": "consonant",
    "glyph": "ढ"
  },
  "dny": {
    "type": "conjunct",
    "glyph": "ज्ञ"
  },
  "e": {
    "type": "vowel",
    "glyph": "ए",
    "matra": "े"
  },
  "ee": {
    "type": "vowel",
    "glyph": "ई",
    "matra": "ी"
  },
  "g": {
    "type": "consonant",
    "glyph": "ग"
  },
  "gh": {
    "type": "consonant",
    "glyph": "घ"
  },
  "gy": {
    "type": "conjunct",
    "glyph": "ज्ञ"
  },
  "h": {
    "type": "consonant",
    "glyph": "ह"
  },
  "H": {
    "type": "mark",
    "glyph": "ः"
  },
  "i": {
    "type": "vowel",
    "glyph": "इ",
    "matra": "ि"
  },
  "I": {
    "type": "vowel",
    "glyph": "ई",
    "matra": "ी"
  },
  "ī": {
    "type": "vowel",
    "glyph": "ई",
    "matra": "ी"
  },
  "ii": {
    "type": "vowel",
    "glyph": "ई",
    "matra": "ी"
  },
  "j": {
    "type": "consonant",
    "glyph": "ज"
  },
  "jh": {
    "type": "consonant",
    "glyph": "झ"
  },
  "k": {
    "type": "consonant",
    "glyph": "क"
  },
  "kh": {
    "type": "consonant",
    "glyph": "ख"
  },
  "l": {
    "type": "consonant",
    "glyph": "ल"
  },
  "L": {
    "type": "consonant",
    "glyph": "ळ"
  },
  "m": {
    "type": "consonant",
    "glyph": "म"
  },
  "M": {
    "type": "mark",
    "glyph": "ं"
  },
  "MM": {
    "type": "mark",
    "glyph": "ँ"
  },
  "n": {
    "type": "consonant",
    "glyph": "न"
  },
  "N": {
    "type": "consonant",
    "glyph": "ण"
  },
  "ng": {
    "type": "consonant",
    "glyph": "ङ"
  },
  "ny": {
    "type": "consonant",
    "glyph": "ञ"
  },
  "o": {
    "type": "vowel",
    "glyph": "ओ",
    "matra": "ो"
  },
  "p": {
    "type": "consonant",
    "glyph": "प"
  },
  "ph": {
    "type": "consonant",
    "glyph": "फ"
  },
  "r": {
    "type": "consonant",
    "glyph": "र"
  },
  "R": {
    "type": "consonant",
    "glyph": "र"
  },
  "ri": {
    "type": "vowel",
    "glyph": "ऋ",
    "matra": "ृ"
  },
  "s": {
    "type": "consonant",
    "glyph": "स"
  },
  "sh": {
    "type": "consonant",
    "glyph": "श"
  },
  "Sh": {
    "type": "consonant",
    "glyph": "ष"
  },
  "t": {
    "type": "consonant",
    "glyph": "त"
  },
  "T": {
    "type": "consonant",
    "glyph": "ट"
  },
  "th": {
    "type": "consonant",
    "glyph": "थ"
  },
  "Th": {
    "type": "consonant",
    "glyph": "ठ"
  },
  "u": {
    "type": "vowel",
    "glyph": "उ",
    "matra": "ु"
  },
  "U": {
    "type": "vowel",
    "glyph": "ऊ",
    "matra": "ू"
  },
  "ū": {
    "type": "vowel",
    "glyph": "ऊ",
    "matra": "ू"
  },
  "uu": {
    "type": "vowel",
    "glyph": "ऊ",
    "matra": "ू"
  },
  "v": {
    "type": "consonant",
    "glyph": "व"
  },
  "w": {
    "type": "consonant",
    "glyph": "व"
  },
  "W": {
    "type": "consonant",
    "glyph": "व"
  },
  "x": {
    "type": "conjunct",
    "glyph": "क्ष"
  },
  "y": {
    "type": "consonant",
    "glyph": "य"
  },
  "B": {
    "type": "consonant",
    "glyph": "ब"
  },
  "G": {
    "type": "consonant",
    "glyph": "ग"
  },
  "J": {
    "type": "consonant",
    "glyph": "ज"
  },
  "K": {
    "type": "consonant",
    "glyph": "क"
  },
  "P": {
    "type": "consonant",
    "glyph": "प"
  },
  "V": {
    "type": "consonant",
    "glyph": "व"
  },
  "X": {
    "type": "conjunct",
    "glyph": "क्ष"
  },
  "Y": {
    "type": "consonant",
    "glyph": "य"
  },
  "E": {
    "type": "vowel",
    "glyph": "ए",
    "matra": "े"
  },
  "O": {
    "type": "vowel",
    "glyph": "ओ",
    "matra": "ो"
  },
  "Ch": {
    "type": "consonant",
    "glyph": "च"
  },
  "Ph": {
    "type": "consonant",
    "glyph": "फ"
  },
  "Bh": {
    "type": "consonant",
    "glyph": "भ"
  },
  "Gh": {
    "type": "consonant",
    "glyph": "घ"
  },
  "Kh": {
    "type": "consonant",
    "glyph": "ख"
  },
  "Ny": {
    "type": "consonant",
    "glyph": "ञ"
  },
  "Ng": {
    "type": "consonant",
    "glyph": "ङ"
  }
}
